/*@ngInject*/
const DeleteFormRowRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.deleteFormRow = function (uiRowIds) {
        let url = '/rest/FormRow/rows',
            config = {
                params: {
                    rowId: uiRowIds
                }
            };
        return this.delete(url, config);
    };
};

angular.module('umFormViewer')
    .service('deleteFormRowRepository', DeleteFormRowRepository);
